import { render, staticRenderFns } from "./SalaryPaymentsTab.vue?vue&type=template&id=4f3adf2e&scoped=true"
import script from "./SalaryPaymentsTab.vue?vue&type=script&lang=js"
export * from "./SalaryPaymentsTab.vue?vue&type=script&lang=js"
import style0 from "./SalaryPaymentsTab.vue?vue&type=style&index=0&id=4f3adf2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3adf2e",
  null
  
)

export default component.exports